import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useUser } from "@/contexts/UserContext";
import { canAccessCopilot } from "@/utils/accessControl";

/**
 * Wraps the real (non-demo) Risk Copilot routes.
 * - Not logged in → redirect to demo
 * - Logged in but not copilot tier → redirect to demo
 * - Copilot tier → render children
 */
export function RMAccessGate({ children }: { children: React.ReactNode }) {
  const { user, loading: authLoading } = useAuth();
  const { currentUser, loading: userLoading } = useUser();
  const navigate = useNavigate();

  const isLoading = authLoading || userLoading;

  useEffect(() => {
    if (isLoading) return;

    if (!user || !canAccessCopilot(currentUser.plan)) {
      navigate("/risk-copilot/demo", { replace: true });
    }
  }, [isLoading, user, currentUser.plan, navigate]);

  if (isLoading) {
    return (
      <div className="min-h-[50vh] flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  if (!user || !canAccessCopilot(currentUser.plan)) {
    return null; // Will redirect via useEffect
  }

  return <>{children}</>;
}
